import React from "react";
import LogoSvg from "../svg/LogoSvg";
// import LogoSvgDark from "../svg/LogoSvgDark";
const Logo = ({ href }) => {
  return (
    <a href={href} className="site_branding">
      <LogoSvg />
      {/* <LogoSvgDark /> */}
    </a>
  );
};

export default Logo;
